import * as tslib_1 from "tslib";
import { API } from 'aws-amplify';
function mergeScopeIntoInit(init, viewAsScopeService) {
    if (!viewAsScopeService.isEnabled()) {
        return init;
    }
    var scope = viewAsScopeService.getScope();
    if (!scope || !scope.enabled) {
        return init;
    }
    var scopeParams = {};
    if (scope.distiId != null && scope.distiId !== '') {
        scopeParams.disti_id = String(scope.distiId);
    }
    if (scope.clientId != null && scope.clientId !== '') {
        scopeParams.client_id = String(scope.clientId);
    }
    if (scope.campusId != null && scope.campusId !== '') {
        scopeParams.campus_id = String(scope.campusId);
    }
    if (Object.keys(scopeParams).length === 0) {
        return init;
    }
    var initObj = init && typeof init === 'object' ? init : {};
    var merged = tslib_1.__assign({}, initObj);
    // Merge into queryStringParameters (do not overwrite existing)
    var existingQs = merged.queryStringParameters && typeof merged.queryStringParameters === 'object'
        ? merged.queryStringParameters
        : {};
    var mergedQs = tslib_1.__assign({}, existingQs);
    for (var _i = 0, _a = Object.entries(scopeParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (mergedQs[key] === undefined || mergedQs[key] === null || mergedQs[key] === '') {
            mergedQs[key] = value;
        }
    }
    merged.queryStringParameters = mergedQs;
    // Merge into body when it's a plain object (POST/PUT)
    if (merged.body && typeof merged.body === 'object' && !Array.isArray(merged.body)) {
        var body = merged.body;
        var mergedBody = tslib_1.__assign({}, body);
        for (var _c = 0, _d = Object.entries(scopeParams); _c < _d.length; _c++) {
            var _e = _d[_c], key = _e[0], value = _e[1];
            if (mergedBody[key] === undefined ||
                mergedBody[key] === null ||
                mergedBody[key] === '') {
                mergedBody[key] = value;
            }
        }
        merged.body = mergedBody;
    }
    return merged;
}
function wrapApiMethod(original, viewAsScopeService) {
    var _this = this;
    return function (apiName, path, init) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var mergedInit;
        return tslib_1.__generator(this, function (_a) {
            mergedInit = mergeScopeIntoInit(init, viewAsScopeService);
            return [2 /*return*/, original.call(API, apiName, path, mergedInit)];
        });
    }); };
}
/**
 * Patches the Amplify API to inject View As scope params (client_id, campus_id, disti_id)
 * into all requests when View As is enabled.
 * Must be called after Amplify.configure() in app initialization.
 */
export function patchAmplifyApiForViewAsScope(viewAsScopeService) {
    var originalGet = API.get.bind(API);
    var originalPost = API.post.bind(API);
    var originalPut = API.put.bind(API);
    var originalDel = API.del.bind(API);
    API.get = wrapApiMethod(originalGet, viewAsScopeService);
    API.post = wrapApiMethod(originalPost, viewAsScopeService);
    API.put = wrapApiMethod(originalPut, viewAsScopeService);
    API.del = wrapApiMethod(originalDel, viewAsScopeService);
}
